document.addEventListener("DOMContentLoaded", function () {
    const stickyCountertop = document.querySelector('#stickyCountertop');
    const closeBtn = stickyCountertop.querySelector('.js-sticky-countertop-close');
    const imageWrapper = stickyCountertop.querySelector('.js-sticky-countertop-image');
    const addToCartBtn = stickyCountertop.querySelector('.js-sticky-countertop-add-to-cart')

    const faucetsPopup = document.querySelector('#faucets-popup');
    const faucetsCloseBtn = faucetsPopup.querySelector('.faucets-popup-close');
    const faucetsOverlay = faucetsPopup.querySelector('.faucets-popup-overlay');
    const faucetsModal = faucetsPopup.querySelector('.faucets-popup-modal');
    const faucetsItems = faucetsPopup.querySelectorAll('.faucets-popup-faucet');

    closeBtn.addEventListener('click', () => {
      stickyCountertop.classList.remove('active');
    })

    addToCartBtn.addEventListener('click', () => {
      faucetsPopup.classList.add('active');
    })

    imageWrapper.addEventListener("click", () => {
      const src = imageWrapper.dataset.src;

      if (!src) return;

      Fancybox.show([{ src: src, type: 'image' }]);
    });

    faucetsCloseBtn.addEventListener('click', () => {
      faucetsPopup.classList.remove('active');
    })

    faucetsOverlay.addEventListener('click', (e) => {
      faucetsPopup.classList.remove('active');
    })

    faucetsModal.addEventListener('click', (e) => {
      e.stopPropagation();
    })

    faucetsItems.forEach(faucetsItem => {
      faucetsItem.addEventListener('click', (e) => {
        const faucetVariantId = +e.currentTarget.dataset.faucetId;
        const countertopVariantId = +addToCartBtn.dataset.variantId;

        const items = [
          { id: faucetVariantId, quantity: 1 },
          { id: countertopVariantId, quantity: 1 }
        ];

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        })
        .then(response => {
          if (!response.ok) throw new Error('Failed to add to cart');
          return response.json();
        })
        .then(data => {
          console.log('Added to cart:', data);
          window.location.href = '/cart';
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });
      })
    })
})